import { DirectiveBinding, Directive } from 'vue';
import { isObject } from '@/helpers/utils';

const callFunction = (binding: DirectiveBinding) => {
  if (typeof binding.value === 'function') binding.value();
};

const handleAttribute = (el: Element, { modifiers, value }: DirectiveBinding) => {
  if (modifiers.attr && value) {
    if (!isObject(value)) {
      throw new Error('Value for directive v-visibility with modifier attr should be object');
    }
    Object.entries(value).forEach(([attrName, attrValue]) => {
      el.setAttribute(attrName, String(attrValue));
    });
  }
};

const onVisible = (el: Element, binding: DirectiveBinding) => {
  callFunction(binding);
  handleAttribute(el, binding);
};

export default {
  mounted(el: Element, binding: DirectiveBinding) {
    if ('IntersectionObserver' in window) {
      const onIntersection = (
        entries: IntersectionObserverEntry[],
        observer: IntersectionObserver,
      ) => {
        entries.forEach((entry) => {
          // Are we in viewport?
          if (entry.intersectionRatio > 0) {
            onVisible(entry.target, binding);
            observer.disconnect();
          }
        });
      };
      const observer = new IntersectionObserver(onIntersection, {
        // Expand viewport 50 px bottom to load image early
        rootMargin: `${binding.arg || '0px'} 0px`,
        // request percent of image in viewport to load it
        threshold: 0.01,
      });
      observer.observe(el);
    } else {
      // if IntersectionObserver if not support by browser, trigger visible immediately
      onVisible(el, binding);
    }
  },
} as Directive;
